<template>
  <div v-if="questions && questions.answers"
       v-loading="loading"
       class="container_padding"
       style="height:auto;">
    <LearningPageBox>
      <template slot="title">
        <el-button v-if="$route.query.back" class="q-btn-back" @click="$router.go(-1)" size="medium">{{$t('message.back')}}</el-button>
        <div class="question_title">{{questions.title}}</div>
      </template>
      <template slot="content">
        <div class="question"
             style="border:0;">
          <div class="question_items">
            <Question v-for="(item,index) in questions.answers"
                      :key="item.id"
                      :question="item"
                      :index="index"></Question>
          </div>
          <!-- <div class="m-btn question_submit_btn" @click="submit">提交</div> -->
          <div class="question_bottom">
            <div v-if="myQuery && myQuery.type == 'public'" class="captcha">
              <el-input v-model="captcha"
                        :placeholder="$t('message.captcha_plh')"></el-input>
              <img :src="codeImg"
                   alt
                   @click="getCaptcha" />
            </div>
            <mBtn styleSheet="text-align:center;margin:20px 0;"
                  @click="submit"
                  :loading="submitLoading"
                  :disabled="!canSubmit">{{$t('message.submit')}}</mBtn>
          </div>
          <div class="submit_tips">{{$t('message.question_must_be_completed')}}</div>
        </div>
      </template>
    </LearningPageBox>
  </div>
</template>

<script>
import { Base64 } from "js-base64";
import UserQuestionnairesAPI from "../../api/UserQuestionnairesAPI";
import QuestionnaireAPI from "../../api/QuestionnaireAPI";
import mBtn from "../../components/mBtn";
import LearningPageBox from "../../components/LearningPageBox";
import Question from "../../components/Question";
import { basePathUrl } from "../../api/axios";
export default {
  components: { mBtn, LearningPageBox, Question },
  data () {
    return {
      questions: {},
      questionnaireId: null,
      loading: false,
      submitLoading: false,
      basePathUrl: basePathUrl,
      audioUrl: null,
      soundLocale: "TW",
      codeImg: "",
      captcha: null,
    };
  },
  computed: {
    myQuery () {
      let url = this.$route.query.code
        ? Base64.decode(this.$route.query.code)
        : null;
      if (url) {
        let hash;
        var myJson = {};
        var hashes = url.split("&");
        for (var i = 0; i < hashes.length; i++) {
          hash = hashes[i].split("=");
          myJson[hash[0]] = hash[1];
        }
        return myJson;
      } else {
        return null;
      }
    },
    canSubmit () {
      const answers =
        this.questions &&
        this.questions.answers &&
        this.questions.answers.filter(
          (item) => item.question.questionType != "SHORT_ANSWER"
        );
      return answers &&
        answers.find((item) => item.answer == null || item.answer.length < 1)
        ? false
        : true;
    },
  },
  methods: {
    submit () {
      console.log("submit");
      const locale = this.$i18n.locale;
      console.log(locale);
      let questions = JSON.parse(JSON.stringify(this.questions));
      questions.answers.map((item) => {
        console.log(item);
        delete item.question.localeText;
        delete item.question.localeChoices;
        delete item.question.randomAnswer;
        delete item.question.answerAlias;
        delete item.question.randomChoices;
        delete item.question.normalIndexOfRandomChoice;
        delete item.question.localeAnswer;

        if (
          item.question.questionType == "MULTIPLE_CHOICE" ||
          item.question.questionType == "SINGLE_CHOICE"
        ) {
          item.answer = item.answer ? item.answer.toString() : item.answer;
        }
        return item;
      });
      console.log(questions);
      if (this.myQuery && this.myQuery.type == "public") {
        this.submitLoading = true;
        QuestionnaireAPI.submit(questions, this.captcha, locale)
          .then((res) => {
            // console.log(res);
            this.submitLoading = false;
            this.$router.push({
              path: "/success",
              query: {
                code: this.$route.query && this.$route.query.code,
              },
            });
          })
          .catch((err) => {
            this.submitLoading = false;
            console.log(err);
            if (err.status == 401) {
              this.$message({
                message: this.$t("message.errorMessage.captchaError"),
                type: "error",
              });
            } else {
              this.$message({
                message: this.$t("message.submit_error"),
                type: "error",
              });
              // this.$error(err);
            }
            this.getCaptcha();
          });
      } else {
        this.submitLoading = true;
        UserQuestionnairesAPI.submit(questions, locale)
          .then((res) => {
            // console.log(res);
            this.submitLoading = false;
            if(this.$route.query.back){
              this.$alert(this.$t("message.submit_success"), this.$t('message.tips'), {
                confirmButtonText: this.$t('message.back'),
                callback: action => {
                  this.$router.go(-1);
                }
              });
            }else{
              this.$message({
                message: this.$t("message.submit_success"),
                type: "success",
              });
              this.$router.push("/index");
            }
          })
          .catch((err) => {
            this.$error(err);
            console.log(err);
            this.submitLoading = false;
            this.$message({
              message: this.$t("message.submit_error"),
              type: "error",
            });
          });
      }
    },
    get () {
      const questionnaireId = this.questionnaireId;
      const locale = this.$i18n.locale;
      const group = (this.myQuery && this.myQuery.group) || null;
      console.log("group", group);
      // console.log(locale);
      if (this.myQuery && this.myQuery.type == "public") {
        this.loading = true;
        QuestionnaireAPI.listQuestionByQuestionnaire(
          questionnaireId,
          locale,
          group
        )
          .then((res) => {
            // console.log(res);
            this.loading = false;
            if (!res) {
              // alert(this.$t("message.public_questionnaires_Invalid"));
              this.$alert(
                this.$t("message.public_questionnaires_Invalid"),
                this.$t("message.tips"),
                {
                  confirmButtonText: "確認",
                  callback: (action) => {
                    var userAgent = navigator.userAgent;
                    if (
                      userAgent.indexOf("Firefox") != -1 ||
                      userAgent.indexOf("Chrome") != -1 ||
                      userAgent.indexOf("Safari") != -1
                    ) {
                      window.location.href = "about:blank";
                    } else {
                      window.opener = null;

                      window.open("", "_self");

                      window.close();
                    }
                  },
                }
              );
              return false;
            }
            res.answers = res.answers.map((item) => {
              if (item.question.questionType == "MULTIPLE_CHOICE") {
                item.answer = item.answer ? item.answer : [];
              }
              return item;
            });
            this.questions = res;

            this.getCaptcha();
          })
          .catch((err) => {
            this.loading = false;
            this.$error(err);
          });
      } else {
        this.loading = true;
        UserQuestionnairesAPI.listQuestionByQuestionnaire(
          questionnaireId,
          locale,
          group
        )
          .then((res) => {
            console.log("res", res);
            this.loading = false;
            if (res) {
              res.answers = res.answers.map((item) => {
                if (item.question.questionType == "MULTIPLE_CHOICE") {
                  item.answer = item.answer ? item.answer : [];
                }
                return item;
              });
              this.questions = res;
            } else {
              this.$alert(
                this.$t("message.question_already"),
                this.$t("message.tips"),
                {
                  confirmButtonText: this.$t("message.confirm"),
                  showClose: false,
                  callback: (action) => {
                    this.$router.go(-1);
                  },
                }
              );
            }
            this.getCaptcha();
          })
          .catch((err) => {
            this.loading = false;
            this.$error(err);
            console.log(err);
          });
      }
    },
    getCaptcha () {
      let _this = this;
      QuestionnaireAPI.captcha()
        .then((res) => {
          let codeImg =
            "data:image/png;base64," +
            btoa(
              new Uint8Array(res).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            );
          _this.codeImg = codeImg;
        })
        .catch((err) => {
          _this.$error(err);
        });
    },
  },
  created () {
    this.soundLocale = localStorage.getItem("sound");
    // let type;
    // let id;

    // let url = this.$route.query.code
    //   ? Base64.decode(this.$route.query.code)
    //   : null;
    // if (url) {
    //   let hash;
    //   var myJson = {};
    //   var hashes = url.split("&");
    //   for (var i = 0; i < hashes.length; i++) {
    //     hash = hashes[i].split("=");
    //     myJson[hash[0]] = hash[1];
    //   }
    //   type = myJson.type;
    //   id = myJson.id;
    // }

    const type = this.myQuery.type;
    const id = parseInt(this.myQuery.id);
    this.questionnaireId = id;
    // if(type == 'public'){
    //   document.title = this.$t('message.question_public_title')
    // }
    if (!type || !id) {
      this.$router.push("/");
      return;
    }
    this.get();
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-radio {
  // padding: 15px 0;
}
/deep/.el-radio,
.el-radio__label {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.answer_radios_items {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 50px;
  position: relative;
  padding-top: 15px;
  padding-bottom: 15px;
}

.submit_tips {
  font-size: 14px;
  color: #333;
  text-align: center;
}
.captcha {
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 300px;
  img {
    height: 50px;
  }
}
.q-btn-back{
  position: absolute;
  left: 15px;
  top: 7px;
}
.question_bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media screen and (min-width: 992px) {
  /deep/.el-textarea__inner {
    font-size: 20px;
  }
}
@media screen and (max-width: 991px) {
  /deep/.el-textarea__inner {
    font-size: 14px;
  }
}
</style>